import React from 'react';
import { UsersIcon, WalletIcon, SparklesIcon, BoxIcon } from 'lucide-react';
interface Extra {
  num: string;
  title: string;
  desc: string;
  Icon: BoxIcon;
  highlight?: boolean;
}
export function Extra() {
  const extras: Extra[] = [{
    num: 'Tomo 07',
    title: 'Gestión del equipo de trabajo',
    desc: 'Sin este tomo, el sistema clínico sigue dependiendo de vos. Con este, tu asistente sabe exactamente qué hacer sin preguntarte. Incluye onboarding, roles, reunión semanal y protocolo de esterilización.',
    Icon: UsersIcon
  }, {
    num: 'Tomo 08',
    title: 'Economía del consultorio',
    desc: 'Trabajás todo el mes y no sabés a dónde va la plata. Este tomo cierra ese agujero: costos fijos, punto de equilibrio, protocolo de cobro, precios con criterio de inflación y los 5 indicadores que tenés que medir cada mes.',
    Icon: WalletIcon
  }, {
    num: 'Por qué es irresistible',
    title: 'La diferencia más barata que vas a encontrar',
    desc: 'Por $8.000 pesos más obtenés el sistema completo para crecer, delegar y controlar la economía. Dos tomos que resuelven lo que el sistema clínico solo no puede: el equipo y la plata.',
    Icon: SparklesIcon,
    highlight: true
  }];
  return <section className="bg-white px-5 py-10 md:py-[70px] text-center" data-id="element-43">
      <div className="mx-auto max-w-[960px]" data-id="element-44">
        <h2 className="mb-6 md:mb-[44px] font-bebas text-[clamp(28px,5vw,48px)] text-navy" data-id="element-45">
          ¿Qué agrega la Edición Completa?
        </h2>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-46">
          {extras.map((extra, i) => <div key={i} className={`flex flex-col rounded-xl border-[1.5px] p-5 text-left transition-all hover:-translate-y-0.5 hover:shadow-md ${extra.highlight ? 'border-gold bg-gold/5' : 'border-brandGray-light bg-white'}`} data-id="element-47">
              <span className={`mb-3 flex h-11 w-11 items-center justify-center rounded-lg ${extra.highlight ? 'bg-gold/15 text-gold' : 'bg-brandRed/10 text-brandRed'}`} data-id="element-48">
                <extra.Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-49" />
              </span>
              <p className={`mb-1.5 font-montserrat text-[11px] font-black uppercase tracking-[2px] ${extra.highlight ? 'text-gold' : 'text-brandRed'}`} data-id="element-50">
                {extra.num}
              </p>
              <p className="mb-2 font-montserrat text-[15px] font-extrabold text-navy" data-id="element-51">
                {extra.title}
              </p>
              <p className="text-[13px] leading-relaxed text-brandGray" data-id="element-52">
                {extra.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}